'use strict';

var measureHelper = require('../../helper/measureHelper');
var styleHelper = require('../../helper/styleHelper');


exports.getComAutoSize = function (props, text) {
  var measureText = text ? text : styleHelper.getText(props);
  var textArray = measureText.split('\n');
  var isMultiLineText = textArray.length > 1;
  var maxLengthText;
  var i;

  var measureStyle = {
    fontSize: styleHelper.getFontSize(props) || 14,
    fontStyle: props.textStyles ? props.textStyles.fontStyle : 'normal',
    textDecoration: props.textStyles ? props.textStyles.textDecoration : 'normal',
    fontWeight: props.textStyles ? props.textStyles.fontWeight : 'normal',
    fontFamily: props.textFontFamily || ''
  };

  if (isMultiLineText) {
    maxLengthText = measureText;
  } else {
    maxLengthText = textArray[0];
    for (i = 1; i < textArray.length; i++) {
      if (textArray[i].length > maxLengthText.length) {
        this.maxLengthText = textArray[i];
      }
    }
  }

  return measureHelper.measureTextWidth(measureStyle, maxLengthText);

};


// WEBPACK FOOTER //
// ./src/views/common/AutoSizeHelper.js